import classnames from 'classnames';
import React from 'react';

interface Props {
  name: string;
  selected: boolean;
  onClick: (name: string, index: number) => void;
  index: number;
  activeCount: number;
  errorCount: number;
  hasNewActivity: boolean;
  placeholder?: string;
  title?: string;
}

class Tab extends React.Component<Props> {
  static defaultProps = {
    selected: false,
    onClick: (n: string, i: number): void => {},
    index: 0,
    activeCount: 0,
    errorCount: 0,
    hasNewActivity: false,
  };

  handleTabClick = (): void => {
    this.props.onClick(this.props.name, this.props.index);
  };

  render(): React.ReactNode {
    const {
      selected,
      activeCount,
      errorCount,
      hasNewActivity,
      placeholder,
      title,
    } = this.props;

    const name = this.props.title ? this.props.title : this.props.name;

    return (
      <div className="w100 cursor-pointer pos-r" onClick={this.handleTabClick}>
        <div
          className={classnames('font-size-5 center row', {
            'color-primary-dark': selected,
            'color-gray-4': !selected,
          })}
          style={{ margin: '4px' }}
        >
          <div className="grow-1" />
          <div className="grow-0 row justify-center">
            {placeholder && placeholder !== '' ? placeholder : name}
            {hasNewActivity && (
              <div
                style={{
                  backgroundColor: '#a73f8e',
                  borderRadius: '50%',
                  margin: '4px -16px 0 6px',
                  width: '10px',
                  height: '10px',
                }}
              />
            )}
          </div>
          <div className="grow-1 row items-center">
            {(() => {
              if (errorCount > 0 || activeCount > 0) {
                const backgroundColor = errorCount > 0 ? '#de3428' : '#a73f8e';
                const count = errorCount > 0 ? errorCount : activeCount;
                return (
                  <div
                    className="b-1 white-2 b-radius-3 ml2"
                    style={{
                      width: '22px',
                      height: '16px',
                      lineHeight: '16px',
                      borderRadius: '8px',
                      backgroundColor,
                      fontSize: '10px',
                      textAlign: 'center',
                      marginRight: '-30px',
                    }}
                  >
                    <div>{count}</div>
                  </div>
                );
              }
              return null;
            })()}
          </div>
        </div>

        <div
          className={classnames(
            'bb-solid bb-width-3',
            selected ? 'bb-primary-dark' : 'bb-transparent'
          )}
        />
      </div>
    );
  }
}

export default Tab;
